import React, { useState, useEffect, useRef, useMemo } from "react";
import { Button, Input, Space, Table, message } from "antd";
import axios from "axios";
import IconButton from "@mui/material/IconButton";
import { ExpandAltOutlined } from "@ant-design/icons";
import { SearchOutlined } from "@ant-design/icons";
import { saveAs } from "file-saver";
import Papa from "papaparse";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Highlighter from "react-highlight-words";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Toolbar from "@mui/material/Toolbar";
import Stats from "../tester-teamlead/tester-stats";

const apiUrl =
  "https://glzf596ea7.execute-api.us-east-1.amazonaws.com/dev/get_all_testers_bonuses";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const Bonuses = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [testers, setTesters] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [open, setOpen] = useState(false);
  const [reload, setReload] = useState(false);
  const [searchedColumn, setSearchedColumn] = useState("");
  const [selectedTester, setSelectedTester] = useState(null);
  const [sortOrder, setSortOrder] = useState("desc");
  const [loading, setLoading] = useState(true);
  const [initialBonus, setInitialBonus] = useState("");
const [editedBonus, setEditedBonus] = useState("");
const [testerDetails, setTesterDetails] = useState(null);

const isBonusChanged = useMemo(() => initialBonus !== editedBonus, [initialBonus, editedBonus]);
  const searchInput = useRef(null);
  useEffect(() => {
    fetchData();
  }, [reload]);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const handleViewClick = async (record) => {
    setOpen(true);
    try {
      const res = await axios.get(
        `https://glzf596ea7.execute-api.us-east-1.amazonaws.com/dev/get_tester_details/${record.user_id}`
      );
      
      if (res.status === 200 && res.data.body) {
        const data = JSON.parse(res.data.body);
        setTesterDetails(data);
        setInitialBonus(data.current_month_bonus);
        setEditedBonus(data.current_month_bonus);
      } else {
        messageApi.error("Failed to fetch tester details");
      }
    } catch (err) {
      console.error(err);
      messageApi.error("Something went wrong while fetching details");
    }
  };
  
  

  const handleDownloadCsv = async () => {
    await fetchData();
    const downloadData = sortedUsers.map((item) => ({
      First_Name: item.first_name,
      Last_Name: item.last_name,
      Email: item.email,
      Current_Month_Count: item.current_month_count,
      Previous_Month_Count: item.previous_month_count,
      Bonus: item.payment,
    }));
  
    const csvData = Papa.unparse(downloadData);
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8" });
    saveAs(blob, "Bonuses.csv");
  };
  

  useEffect(() => {
    fetchData();
  }, []);

  const storedUser = localStorage.getItem("user");
  const user = JSON.parse(storedUser);

  const calculatePayment = (count) => {
    let payment = 0;
    payment = count * 0.01;
    return payment.toFixed(3);
  };

  const sortedUsers = useMemo(() => {
    return [...testers].sort((a, b) => {
      if (sortOrder === "desc") {
        return b.after12_valid_count - a.after12_valid_count;
      } else {
        return a.after12_valid_count - b.after12_valid_count;
      }
    });
  }, [testers, sortOrder]);

  const fetchData = async () => {
    try {
      const response = await fetch(apiUrl);
      if (!response.ok) {
        throw new Error("Failed to fetch testers");
      }
  
      const result = await response.json();
      console.log('result', result)
      const parsedData = JSON.parse(result.body);
      console.log('parsedData', parsedData)
  
      const testersWithPayment = parsedData.data.map((tester) => ({
        ...tester,
        payment: calculatePayment(tester.previous_month_count),
      }));
  
      setTesters(testersWithPayment);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching testers:", error);
      setTesters([]);
      setLoading(false);
    }
  };
  
  
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />

        <Space>
          <Button
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
            type="secondary"
            className="bg-[blue] text-[white]"
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1677ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: "Tester Name",
      dataIndex: "first_name",
      key: "first_name",
      width: "15%",
      ...getColumnSearchProps("first_name"),
      sorter: (a, b) => a.first_name.localeCompare(b.first_name),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: "10%",
      ...getColumnSearchProps("email"),
    },
    {
      title: "Current Month Count",
      dataIndex: "current_month_count",
      key: "current_month_count",
      sorter: (a, b) => a.current_month_count - b.current_month_count,
      width: "15%",
      defaultSortOrder: "descend",
    },
    {
      title: "Previous Month Count",
      dataIndex: "previous_month_count",
      key: "previous_month_count",
      sorter: (a, b) => a.previous_month_count - b.previous_month_count,
      width: "15%",
    },
    {
      title: "Bonus (USD)",
      dataIndex: "current_month_bonus",
      key: "current_month_bonus",
      sorter: (a, b) => a.current_month_bonus - b.current_month_bonus,
      width: "10%",
    },
    {
        title: "Actions",
        key: "view",
        width: "20%",
        render: (text, record) => (
          <Space>
            <Button
              icon={<ExpandAltOutlined />}
              onClick={() => handleViewClick(record)}
            >
              Add Bonus
            </Button>
          </Space>
        ),
      }
      
  ];
  
  return (
    <>
      {contextHolder}

      <AppBar
        position="relative"
        sx={{
          backgroundColor: "#fff",
          boxShadow: "none",
          padding: "0.5rem 1rem",
        }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography
            variant="h6"
            component="div"
            sx={{ fontWeight: "bold", color: "#333" }}
          >
           Bonuses for all Testers
          </Typography>
          <Button
            variant="contained"
            onClick={handleDownloadCsv}
            sx={{
              backgroundColor: "#3f51b5",
              color: "#fff",
              "&:hover": {
                backgroundColor: "#303f9f",
              },
            }}
          >
            Download CSV
          </Button>
        </Toolbar>
      </AppBar>

      {testers && (
        <>
          <Table
            columns={columns}
            dataSource={sortedUsers}
            loading={loading}
            locale={{
              emptyText: loading ? "Loading..." : "No Data",
            }}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: 5,
              pageSizeOptions: ["5", "10", "20"],
            }}
            scroll={{ x: "100%" }}
          />
        </>
      )}

      {!testers && <p>No records found.</p>}

      <Dialog
  open={open}
  onClose={() => setOpen(false)}
  TransitionComponent={Transition}
  maxWidth="md"
  fullWidth
  PaperProps={{
    sx: {
      width: {
        xs: '90%',
        sm: '70%',
        md: '75%',
        lg: '40%',
      },
      height: {
        xs: 'auto',
        sm: '60%',
        md: '90%',
      },
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      borderRadius: 2,
    },
  }}
  style={{ zIndex: 20 }}
>
  <AppBar sx={{ position: "relative" }}>
    <Toolbar>
      <IconButton
        edge="start"
        color="inherit"
        onClick={() => setOpen(false)}
        aria-label="close"
      >
        <CloseIcon />
      </IconButton>
      <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
        Add Bonus
      </Typography>
      {/* <Typography variant="body1" component="div">
        {testerDetails?.first_name} {testerDetails?.last_name}
      </Typography> */}
    </Toolbar>
  </AppBar>

  {/* Main Content */}
  <Box sx={{ p: 3, flexGrow: 1 }}>
  <Grid container spacing={2}>
  <Grid item xs={6}>
    <Typography variant="subtitle2">First Name</Typography>
    <Input value={testerDetails?.first_name || ""} disabled style={{ width: "100%" }} />
  </Grid>
  <Grid item xs={6}>
    <Typography variant="subtitle2">Last Name</Typography>
    <Input value={testerDetails?.last_name || ""} disabled style={{ width: "100%" }} />
  </Grid>
  <Grid item xs={12}>
    <Typography variant="subtitle2">Email</Typography>
    <Input value={testerDetails?.email || ""} disabled style={{ width: "100%" }} />
  </Grid>
  <Grid item xs={6}>
    <Typography variant="subtitle2">Current Month Count</Typography>
    <Input value={testerDetails?.current_month_count ?? ""} disabled style={{ width: "100%" }} />
  </Grid>
  <Grid item xs={6}>
    <Typography variant="subtitle2">Previous Month Count</Typography>
    <Input value={testerDetails?.previous_month_count ?? ""} disabled style={{ width: "100%" }} />
  </Grid>
  <Grid item xs={12}>
    <Typography variant="subtitle2">Bonus (USD)</Typography>
    <Input
      value={editedBonus}
      onChange={(e) => setEditedBonus(e.target.value)}
      style={{ width: "100%" }}
      type="number"
      step="0.01"
    />
  </Grid>
</Grid>
 </Box>

  {/* Footer Save Button */}
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'flex-end',
      p: 2,
      borderTop: '1px solid #ddd',
    }}
  >
    <Button
       variant="contained"
  color="primary"
      disabled={!isBonusChanged}
      onClick={async () => {
        console.log('testerDetails',testerDetails)
        try {
            const response = await axios.post("https://glzf596ea7.execute-api.us-east-1.amazonaws.com/dev/add-bonus-for-tester", {
              tester_id: testerDetails.id,
              bonus_amount: editedBonus,
            });
          
            const data = response.data;
          
            if (data.statusCode !== 200) {
              // handle error here
              console.error(data.error);
              messageApi.error("Failed to update bonus");
            } else {
              messageApi.success("Bonus updated successfully");
              setOpen(false);
              setReload(!reload);
            }
          
          } 
          catch (error) {
            messageApi.error("Failed to update bonus");
          }
          
      }}
    >
      Save
    </Button>
  </Box>
</Dialog>

    </>
  );
};

export default Bonuses;
